import "./Nav.css"
import { filter, first, length, map } from "@pdfking/rfunc"
import { RecordMerge } from "@pdfking/tfunc"
import Icon from "@pdfking/workflow/components/Icon"
import fire_event from "@pdfking/workflow/utils/fire_event"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import { defineComponent, withModifiers } from "vue"
import autocomplete from "../../constants/autocomplete"
import breadcrumbs from "../../constants/breadcrumbs"
import selector from "../../dom/selector"
import close from "../../mixins/Close"
import freeze from "../../mixins/Freeze"
import navigate from "../navigate"
import { NAV_VIEW } from "../urls"
import Filters from "./layout/Filters"
import Results from "./layout/Results"

export default defineComponent({
  computed: RecordMerge(
    proxy(autocomplete(), [
      "pages_index",
      "pages_descendants_by_url",
      "pages_by_url",
    ]),
    {
      html_content() {
        return map(
          (e: HTMLElement) => e.innerHTML,
          // @ts-expect-error - Vue data prop
          selector(this.html_selector)
        ).join("")
      },
      is_main() {
        // @ts-expect-error - Vue prop
        return !this.url
      },
      main_descendants() {
        // @ts-expect-error - Vue prop and proxy
        if (this.url && this.pages_by_url && this.pages_by_url[this.url]) {
          // @ts-expect-error - Vue prop
          let array = this.descendants(this.url)
          // @ts-expect-error - Vue prop
          if (array && this.limit) {
            // @ts-expect-error - Vue prop
            array = array.slice(0, this.limit)
          }
          return map(
            (o: any) =>
              RecordMerge(o, {
                // @ts-expect-error - Vue method
                descendants: this.descendants(o.url),
              }),
            array
          )
        }
      },
      megamenu_content() {
        return map(
          (e: HTMLElement) => ({
            title: e.innerHTML,
            url: e.getAttribute("href"),
          }),
          filter(
            (e: HTMLElement) => e.innerHTML,
            // @ts-expect-error - Vue data prop
            selector(this.megamenu_selector)
          )
        )
      },
      megamenu_filters() {
        return map(
          (el: any) => ({ id: el.url, title: el.title }),
          this.megamenu_content
        )
      },
      translations: () => make_translations("actions"),
    }
  ),
  data() {
    return {
      html_selector: ".main-offcanvas",
      megamenu_selector: ".main-megamenu[href]:not(.menu-0y6hmbho)",
      toggled_class: "search-body",
    }
  },
  methods: {
    descendants(url: string) {
      if (url && this.pages_descendants_by_url) {
        return filter(
          (p: any) => p.in_navigation,
          this.pages_descendants_by_url[url] || []
        )
      }
      return []
    },

    length,
    open_link(url?: string) {
      navigate(NAV_VIEW, url ? { url } : {})
    },
  },
  mixins: [close, freeze],
  async mounted() {
    fire_event(document, "focus_search")
    if (this.url === "auto") {
      for (const url of breadcrumbs().links) {
        for (const { url: cmp } of this.megamenu_content) {
          if (url === cmp) {
            return this.open_link(url)
          }
        }
      }
      return this.open_link(first(this.megamenu_content).url)
    }
  },

  props: ["url", "title", "limit"] as const,
  render() {
    return (
      <div class="position-absolute bg-white z-2 w-100 main-menu overflow-hidden">
        <div class="container position-relative d-flex flex-column h-100">
          <button
            class="btn-close position-absolute top-0 end-0 mx-3 my-4 p-2 rounded-circle border bg-white d-none d-lg-block"
            type="button"
            onClick={this.close}
          />

          {!this.is_main && (
            <a
              class="d-md-none clickable h5 dropdown-item d-block mt-1"
              onClick={withModifiers(
                () => this.open_link(),
                ["stop", "prevent"]
              )}
            >
              <Icon name="ARROW_LEFT" /> {this.translations.actions.SHOW_ALL}
            </a>
          )}
          <div class="row h-100">
            {!this.is_main && (
              <div class="col order-lg-last overflow-scroll overscroll-contain no-scrollbar h-100">
                {!this.main_descendants && !this.is_main ? (
                  <div class="w-100 h-100 text-center">
                    <div class="spinner-border muted m-5 p-5" />
                  </div>
                ) : (
                  this.main_descendants && (
                    <Results pages={this.main_descendants} />
                  )
                )}
              </div>
            )}
            <div class="col-12 col-lg-3 overflow-scroll overscroll-contain no-scrollbar h-100 border-end g-0 me-2">
              {this.megamenu_content && (
                <div class={{ "d-none d-lg-flex": this.main_descendants }}>
                  <Filters
                    action={this.open_link}
                    class="mt-4 w-100"
                    filters={this.megamenu_filters}
                    selected={this.url}
                  />
                </div>
              )}
              {this.html_content && (
                <div
                  class="w-100 d-flex flex-column d-lg-none mb-4 ms-3"
                  innerHTML={this.html_content}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  },
})
